declare namespace $ {

	type $shm_sort__sort_order_shm_list_head_1 = $mol_type_enforce<
		ReturnType< $shm_list_head['sort_order'] >
		,
		ReturnType< $shm_sort['sort_order'] >
	>
	type $shm_sort__sort_by_shm_list_head_2 = $mol_type_enforce<
		ReturnType< $shm_list_head['sort_by'] >
		,
		ReturnType< $shm_sort['sort_by'] >
	>
	type $shm_sort__options_shm_list_head_3 = $mol_type_enforce<
		ReturnType< $shm_list_head['sort_options'] >
		,
		ReturnType< $shm_sort['options'] >
	>
	type $mol_view__sub_shm_list_head_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_shm_list_head_5 = $mol_type_enforce<
		ReturnType< $shm_list_head['add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_list_head_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_shm_list_head_7 = $mol_type_enforce<
		ReturnType< $shm_list_head['close_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_list_head_8 = $mol_type_enforce<
		ReturnType< $shm_list_head['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_list_head_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_list_head_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_search__query_shm_list_head_11 = $mol_type_enforce<
		ReturnType< $shm_list_head['filter'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_list__sub_shm_list_head_12 = $mol_type_enforce<
		ReturnType< $shm_list_head['settings_content'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_pick__hint_shm_list_head_13 = $mol_type_enforce<
		ReturnType< $shm_list_head['settings_hint'] >
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_list_head_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_list_head_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_shm_list_head_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_shm_list_head_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_list_head_18 = $mol_type_enforce<
		ReturnType< $shm_list_head['group_content'] >
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_shm_list_head_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_list_head_20 = $mol_type_enforce<
		ReturnType< $shm_list_head['sort_content'] >
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_shm_list_head_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_list_head_22 = $mol_type_enforce<
		ReturnType< $shm_list_head['filter_content'] >
		,
		ReturnType< $mol_labeler['content'] >
	>
	export class $shm_list_head extends $mol_view {
		sort_order( next?: string ): string
		sort_by( next?: string ): string
		Sort( ): $shm_sort
		Title( ): $mol_view
		head_content( ): readonly($mol_view_content)[]
		add( next?: any ): any
		Add_icon( ): $mol_icon_plus
		Add( ): $mol_button_minor
		add_content( ): readonly(any)[]
		close( next?: any ): any
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		close_content( ): readonly(any)[]
		Head( ): $mol_view
		filter( next?: string ): string
		Filter( ): $mol_search
		Settings_trigger_icon( ): $mol_icon_dots_vertical
		Settings_content( ): $mol_list
		Settings( ): $mol_pick
		Controls( ): $mol_view
		title( ): string
		add_title( ): string
		close_hint( ): string
		settings_hint( ): string
		sort_options( ): ({ 
			'created': string,
			'changed': string,
			'title': string,
		}) 
		group_content( ): readonly(any)[]
		sort_content( ): readonly(any)[]
		filter_content( ): readonly(any)[]
		settings_content( ): readonly(any)[]
		sub( ): readonly(any)[]
		Group_label( ): $mol_labeler
		Sort_label( ): $mol_labeler
		Filter_label( ): $mol_labeler
	}
	
}

//# sourceMappingURL=head.view.tree.d.ts.map